var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image",style:(_vm.style)},[_vm._t("default"),(_vm.$options.isDebugMode)?_c('DebugTile',{attrs:{"bottom":"","left":"","color":"yellow","data":_vm.data}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }